import type { ReactNode } from 'react'

export interface PayoutSplitAllocatorProps {
  splitAssist?: ReactNode
  children?: ReactNode
}

export function PayoutSplitAllocator({
  splitAssist,
  children,
}: PayoutSplitAllocatorProps) {
  return (
    <div>
      <div>{children}</div>
      {splitAssist}
    </div>
  )
}
